import React, { useEffect, useRef, useState } from "react";
import "./users.css";
import { LuListFilter } from "react-icons/lu";
import { useNavigate } from "react-router-dom";
import { GrMoreVertical } from "react-icons/gr";
import { useDispatch } from "react-redux";
import { userDelete, userList } from "../../redux/actions/userAction";
import moment from "moment";
import Loading from "../../components/ui/loader/loader";
import Pagination from "../../components/ui/pagination/pagination";
import errorToast from "../../components/toast/errorToast";
import successToast from "../../components/toast/successToast";
import PageTableLayout from "../../components/ui/PageTableLayout/PageTableLayout";
import { useAuth } from '../../context/AuthContext';

const Users = () => {
  const navigate = useNavigate();
  const dropdownRef = useRef(null);
  const { isAdmin } = useAuth();

  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [userData, setUserData] = useState([]);
  const [filterTerm, setFilterTerm] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [showOptions, setShowOptions] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [showClearIndex, setShowClearIndex] = useState(null);
  const [paginationData, setPaginationData] = useState({});
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const dispatch = useDispatch();

  const handleMoreOptionsClick = (user, index) => {
    setSelectedUser(user);
    setShowOptions(!showOptions);
    setShowClearIndex(index);
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setShowOptions(false);
      setShowClearIndex(null);
    }
  };

  const onSuccess = (data) => {
    setUserData(data.data.data.users);
    setPaginationData(data.data.data.pagination);
    setFilteredData(data.data.data.users);
    setLoading(false);
  };
  const onError = (data) => {
    errorToast(data.data.message);
  };

  const handleDelete = (id) => {
    dispatch(userDelete({ id }, onDeleteSuccess, onError));
  };

  const onDeleteSuccess = (data) => {
    dispatch(userList({ page, page_size: rowsPerPage }, onSuccess, onError));
    setShowOptions(false);
    setShowClearIndex(null);
    successToast(data?.data?.message);
  };

  useEffect(() => {
    document.title = 'Users - Acumen Translation Hub';
  }, []);

  useEffect(() => {
    setLoading(true);
    dispatch(userList({ page, page_size: rowsPerPage }, onSuccess, onError));
  }, [page, rowsPerPage]);

  useEffect(() => {
    setLoading(true);
    dispatch(userList({ page, page_size: rowsPerPage, search: filterTerm }, onSuccess, onError));
  }, [filterTerm]);

  return (
    <PageTableLayout
      title="Users"
      headerActions={isAdmin &&
        <h4
          className="fs_16 fw_600 cursor_pointer text-primary mx-3 mb-0"
          onClick={() => navigate("/inviteUsers")}
        >
          + INVITE USER
        </h4>
      }
      description={
        <div className="text-start">
          <p>
            Portal users sign in and work in a Acumen Translation Hub user to translate content.{" "}
            <a
              href="https://cloud.google.com/translation-hub/docs/admin-enable-translations?_gl=1*1fewv6d*_ga*MzA3NzExMzYyLjE3MTE2ODg5NTg.*_ga_WH2QY8WWF5*MTcxMzMzMDY1My40NS4xLjE3MTMzMzEwMjIuMC4wLjA.&_ga=2.146857653.-307711362.1711688958&_gac=1.24124488.1713330669.Cj0KCQjwqpSwBhClARIsADlZ_Tk7I9CWN_Klw2a7aPHXlup07MsPzxOv51pbpJrr4n2vYoYQDKUWUDgaArWREALw_wcB"
              target="_blank"
              rel="noreferrer"
              className="text-primary text-decoration-underline"
            >
              Learn more
            </a>{" "}
          </p>
          <p>
            Translators review and edit translated content from user users.{" "}
            <a
              href="https://cloud.google.com/translation-hub/docs/admin-enable-post-edits?_gl=1*14gn9p5*_ga*MzA3NzExMzYyLjE3MTE2ODg5NTg.*_ga_WH2QY8WWF5*MTcxMzMzMDY1My40NS4xLjE3MTMzMzEwMjcuMC4wLjA.&_ga=2.218214939.-307711362.1711688958&_gac=1.118936955.1713330669.Cj0KCQjwqpSwBhClARIsADlZ_Tk7I9CWN_Klw2a7aPHXlup07MsPzxOv51pbpJrr4n2vYoYQDKUWUDgaArWREALw_wcB"
              target="_blank"
              rel="noreferrer"
              className="text-primary text-decoration-underline"
            >
              Learn more
            </a>
          </p>
          <p>User users and Translators can&apos;t access your Google Cloud project.</p>
        </div>
      }
      filters={
        <div className="input-group mt-2">
          <span className="input-group-text">
            <LuListFilter />
            &nbsp;Filter
          </span>
          <input
            type="text"
            className="form-control"
            placeholder="Enter user name or value"
            value={filterTerm}
            onChange={(e) => { setPage(1); setFilterTerm(e.target.value) }}
          />
        </div>
      }
      pagination={
        paginationData?.total > 10 ? (
          <Pagination
            data={paginationData}
            nextFunc={() => setPage(page + 1)}
            prevFunc={() => setPage(page - 1)}
            setPageRowFunc={(value) => {
              setPage(1);
              setRowsPerPage(value);
            }}
          />
        ) : null
      }
      onClick={handleClickOutside}
    >
      <thead>
        <tr className="text-start text-nowrap">
          <th width="8%">User Name</th>
          <th width="10%">Sign-in Method</th>
          <th width="8%">Roles</th>
          <th width="8%">Status</th>
          <th width="30%">Portals</th>
          <th width="16%">Create Time</th>
          {isAdmin && <th></th>}
        </tr>
      </thead>
      <tbody>
        {loading ? (
          <tr>
            <td colSpan="7">
              <Loading text={"Loading contents"} style={{ height: "5rem" }} />
            </td>
          </tr>
        ) : filteredData?.length > 0 ? (
          filteredData?.map((item, index) => (
            <tr key={index}>
              <td>{item.email}</td>
              <td>{item.sign_in.toUpperCase()}</td>
              <td>{item.user_type.toUpperCase()}</td>
              <td>{item.status.toUpperCase()}</td>
              <td>{item?.portalUsers?.map((user) => user?.portal?.portal_name).join(", ")}</td>
              <td>{moment(item.createdAt).format('MM/DD/YY, hh:mm A')}</td>
              {isAdmin && (
                <td>
                  <GrMoreVertical
                    className="cursor_pointer"
                    onClick={() => handleMoreOptionsClick(item, index)}
                  />
                  {showOptions && showClearIndex === index && (
                    <div className="position-relative" ref={dropdownRef}>
                      <div className="position-absolute" style={{ left: "-5rem" }}>
                        <div className="card" style={{ width: '5rem' }}>
                          <div className="card-body p-2">
                            <label className="d-block mb-2 cursor_pointer hover-effect" onClick={() => navigate(`/edit-user/${item?.id}`)}>Edit</label>
                            <label className="d-block mb-2 cursor_pointer hover-effect" onClick={() => navigate(`/view-user/${item?.id}`)}>View</label>
                            <label className="d-block text-danger cursor_pointer hover-effect" onClick={() => handleDelete(item?.id)}>Delete</label>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </td>
              )}
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan="7">No rows to display</td>
          </tr>
        )}
      </tbody>
    </PageTableLayout>
  );
};

export default Users;
